import { ownerWeekCopy as t } from "./copy.ts";

export const place = { id: "semana", path: "/semana", view: "semana", route: "GET /api/semana", query: ["de"], title: t.lugar } as const;
